import { element, only } from './definition';
import { look, typeface } from './styleTokens';

// The account page's own content while shoppers have no accounts: a lookup by order number and phone, and
// the order it finds — how far it has come, its parcel, its lines. It is offered only on the account page.

/** The order lookup, as the /account page draws it. */
export const orderLookupElement = element('order-lookup', {
  label: 'Order lookup',
  description: 'Lets a shopper find their order by its number and phone, and shows how far it has come.',
  category: 'Other',
  icon: 'truck',
  binds: only(['account']),
  props: [],
  defaults: { props: {}, styles: look({ width: '100%', fontFamily: typeface('body') }) }
});
